import React from "react";
import { ChevronRightIcon } from "@heroicons/react/outline";

const OngoingProjectCard = ({ project }) => {
  return (
    <>
      <div className=" w-full h-20 my-2">
        <div className="flex flex-row justify-between p-5">
          <div className="flex flex-col">
            <h1 className="text-[#666666] text-lg font-medium">
              {project.identifier}
            </h1>
            <h1 className="text-[#A9A7A5] text-lg font-medium">
              {project.title}
            </h1>
          </div>
          {<ChevronRightIcon className="w-6 mr-6" />}
        </div>
        <div className="flex flex-col items-center">
          <div className=" flex w-full border-t border-[#B3B7C6] px-2"></div>
        </div>
      </div>
    </>
  );
};
export default OngoingProjectCard;
